// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Your Firebase Web App configuration
const firebaseConfig = {
  apiKey: "AIzaSyDGawB5C6Wu_UTINvSKADEDePTkIv6ZtPg",
  authDomain: "globisunpush.firebaseapp.com",
  projectId: "globisunpush",
  storageBucket: "globisunpush.firebasestorage.app",
  messagingSenderId: "908323913325",
  appId: "1:908323913325:web:3b969d138b31533e894964",
  measurementId: "G-LDZWQP8CJJ", // optional
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
export const messaging = getMessaging(app);
